import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/web/components/primitives/select";
import { useBrandSelection } from "@/web/routes/_protected/smb/-dashboard/brandSelection";
import { useSuspendedBrandsForUser } from "@/web/routes/_protected/smb/-dashboard/dashboardData";

/**
 * Brand switcher for the SMB dashboard header.
 *
 * Renders IFF the user belongs to more than one brand — a single-brand user
 * sees nothing (the header is unchanged from today; see docs/MULTI_USER_BRANDS.md
 * §2.1). Built on the existing `Select` primitive, matching the category filter
 * that already lives in this header.
 */
export function BrandSwitcher() {
  const brands = useSuspendedBrandsForUser();
  const { selectedBrandId, setSelectedBrandId } = useBrandSelection();

  // Only appears once there's an actual choice to make.
  if (brands.length <= 1) return null;

  return (
    <Select value={selectedBrandId} onValueChange={setSelectedBrandId}>
      <SelectTrigger aria-label="Switch business" className="max-w-[220px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {brands.map((brand) => (
          <SelectItem key={brand.id.toString()} value={brand.id.toString()}>
            {brand.friendlyName}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
